import { ComponentType } from 'react';

import classNames from 'classnames';

import { BinanceLogo } from '@uikit/icons/BinanceLogo';
import { MsqToken } from '@uikit/icons/MsqToken';
import { UsdtCircle } from '@uikit/icons/UsdtCircle';

const paymentIcon: Record<string, ComponentType<{ className?: string }>> = {
  usdt: ({ className }: { className?: string }) => {
    return <UsdtCircle className={classNames('icon-2xs', className)} />;
  },
  sqr: ({ className }: { className?: string }) => (
    <MsqToken className={classNames('text-neutral-600', className)} />
  ),
  tsqr2: ({ className }: { className?: string }) => (
    <MsqToken className={classNames('text-neutral-600', className)} />
  ),
};

const PaymentIcons = ({ tokens }: { tokens: string[] }) => {
  const tokensResult = [...new Set([...tokens])].map((token) => ({
    TokenIcon: token.toLowerCase() in paymentIcon ? paymentIcon[token.toLowerCase()] : () => <></>,
    tokenSymbol: token,
  }));
  return (
    <div className="flex justify-start gap-2">
      <span className="tag tag-outlined-neutral-300 gap-1 font-medium">
        <BinanceLogo className="icon-[0.875rem] text-[#F3BA2F]" />
        BSC
      </span>
      {tokensResult.length &&
        tokensResult.map(({ TokenIcon, tokenSymbol }) => (
          <span key={tokenSymbol} className="tag tag-outlined-neutral-300 gap-1 font-medium">
            <TokenIcon className="icon-[0.875rem]" />
            {tokenSymbol}
          </span>
        ))}
    </div>
  );
};

export default PaymentIcons;
